// Historial local de patentes consultadas recientemente en el simulador.
// Persiste en localStorage para que automotoras / compradores comparen rápido.

const STORAGE_KEY = "tf_recent_plates";
const MAX_ITEMS = 5;

/** Devuelve el array (vacío si no hay nada o si hay error de parseo). */
export const getRecent = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
};

/** Agrega o reemplaza una entrada en la cabeza del historial. Máximo 5. */
export const addRecent = (entry) => {
  if (!entry || !entry.patente) return getRecent();
  const plate = entry.patente.toUpperCase().trim();
  const now = Date.now();
  const cleaned = (getRecent() || []).filter((x) => x.patente !== plate);
  const next = [{ ...entry, patente: plate, ts: now }, ...cleaned].slice(0, MAX_ITEMS);
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    /* localStorage lleno o bloqueado — falla silenciosa */
  }
  return next;
};

/** Elimina una patente del historial. */
export const removeRecent = (plate) => {
  const next = getRecent().filter((x) => x.patente !== (plate || "").toUpperCase());
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    /* ignore */
  }
  return next;
};

/** Limpia todo el historial. */
export const clearRecent = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
  return [];
};
